<template>
    <BaseModal
        :is-open="isOpen"
        class="overflow-hidden"
        @close="closeModal">
        <button
            style="
                cursor:
                    url(/assets/images/ui/icons/jpg-png/close-cursor.png),
                    pointer;
            "
            @click="closeModal"
            class="absolute inset-0 size-full outline-none" />
        <div
            class="container relative mt-12 flex w-full flex-col items-center justify-center rounded-12 bg-white p-5">
            <header
                class="flex w-full items-center space-x-2 border-b border-ash-45 pb-2 md:space-x-7">
                <AtomIcon
                    name="search"
                    class="size-10 text-accent" />
                <input
                    id="search-input"
                    v-model="query"
                    placeholder="Введите Ваш запрос"
                    class="w-full py-2 text-20/120 font-semibold text-ash outline-none"
                    @input="getProducts" />
                <div class="flex space-x-2 md:space-x-5">
                    <button
                        v-show="query.length > 0"
                        type="button"
                        aria-label="Очистить поле поиска"
                        @click="((query = ''), (list = []))">
                        <AtomIcon
                            name="backspace"
                            width="24"
                            height="24"
                            class="shrink-0 text-ash-300 transition-colors duration-300 hover:text-black" />
                    </button>
                    <button
                        type="button"
                        aria-label="Закрыть поиск"
                        @click="closeModal">
                        <AtomIcon
                            name="close"
                            width="24"
                            height="24"
                            class="shrink-0 text-accent" />
                    </button>
                </div>
            </header>
            <ul
                class="max-h-[75vh] w-full divide-y divide-gray-200 overflow-y-scroll md:max-h-[80vh]">
                <SearchModelItem
                    v-for="(item, index) in list"
                    :key="item.name"
                    :item="item"
                    :data-index="index"
                    class="space-y-2"
                    @click="closeModal" />

                <li
                    v-show="list.length == 0 && query.length > 0"
                    class="flex w-full flex-col items-center space-y-3 py-9">
                    <picture>
                        <source
                            srcset="/assets/images/ui/error/webp/not-found.webp"
                            type="image/webp" />
                        <img
                            width="431"
                            height="448"
                            alt="Ничего не найдено"
                            src="/assets/images/ui/error/jpg-png/not-found.png" />
                    </picture>
                    <p class="text-16/150 font-medium text-accent">
                        Ничего не найдено
                    </p>
                </li>
            </ul>
        </div>
    </BaseModal>
</template>

<script lang="ts" setup>
import AtomIcon from '~/components/atom/atom-icon/AtomIcon.vue'
import BaseModal from '~/components/base/base-modal/BaseModal.vue'
import SearchModelItem from '~/components/modals/search-modal/SearchModelItem.vue'
import type { ProductSearch } from '~/components/modals/search-modal/search-modal.types'

const props = defineProps({
    isOpen: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
})
const emits = defineEmits(['close'])

function closeModal() {
    query.value = ''
    emits('close')
}

//todo: rename all consts
const query = ref('')
const list = ref<ProductSearch[]>([])
const isSticky = ref(false)

//todo: переделать в useDebounceFn

function debounce<T extends (...args: any[]) => void>(func: T, ms: number) {
    let timeout: ReturnType<typeof setTimeout>
    return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
        clearTimeout(timeout)
        timeout = setTimeout(() => func.apply(this, args), ms)
    }
}

//todo: разбить на две функции 1-getData 2-debounceSearchQuery
const getProducts = debounce(async () => {
    if (query.value.length > 2) {
        const { data } = await useApiFetch<Page<ProductSearch[]>>(
            `/v1/search?name=${query.value}`
        )
        list.value = data.value?.data || []
    }
    if (query.value.length < 2) {
        list.value = []
    }
}, 200)

watch(
    () => props.isOpen,
    () => {
        isSticky.value = window.scrollY > 0
    }
)
</script>
